import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { formatUrl } from '@core/utils/attachments-utils';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { DialogEditMaintenanceComponent } from 'app/main/maintenances/dialogs/dialog-edit-maintenance/dialog-maintenances.component';
var TabGeneralComponent = /** @class */ (function () {
    function TabGeneralComponent(matDialog, fuseProgressBarService, authenticationService, maintenancesApi) {
        this.matDialog = matDialog;
        this.fuseProgressBarService = fuseProgressBarService;
        this.authenticationService = authenticationService;
        this.maintenancesApi = maintenancesApi;
        this.hasPaymentsBetaFlag = this.authenticationService.hasFlags('paymentsFeatureFlag');
        this.expensesTotalValue = 0;
        this.hasEditMaintenancePermission = this.authenticationService.hasPermission('maintenances-edit');
        this.hasLabelViewPermission = this.authenticationService.hasPermission('labels-list');
    }
    TabGeneralComponent.prototype.ngOnInit = function () {
        var e_1, _a;
        try {
            for (var _b = tslib_1.__values(this.quotation.expenses || []), _c = _b.next(); !_c.done; _c = _b.next()) {
                var expense = _c.value;
                this.expensesTotalValue += expense.value;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    TabGeneralComponent.prototype.editDialog = function (maintenance, isViewMode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        return [4 /*yield*/, this.maintenancesApi.searchOne(this.quotation.maintenance.id).toPromise()];
                    case 1:
                        maintenance = _a.sent();
                        this.fuseProgressBarService.hide();
                        return [4 /*yield*/, this.matDialog.open(DialogEditMaintenanceComponent, {
                                panelClass: 'dialog-edit-maintenance',
                                data: {
                                    maintenance: maintenance,
                                    isViewMode: isViewMode
                                }
                            })
                                .afterClosed()
                                .toPromise()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TabGeneralComponent.prototype.openReceipt = function (item) {
        window.open(formatUrl(item.path), '_blank');
    };
    return TabGeneralComponent;
}());
export { TabGeneralComponent };
